// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ut_3m","name":"styles_name__1Teva","phone":"styles_phone__2drpv"};